import { useNavigate } from 'react-router';

import Text from '@cartwhl/ui/base/TextNew';
import Button from '@cartwhl/ui/input/Button';

export default function DashboardLibraryPrompt() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center gap-4 px-2 pt-8 text-center">
      <Text token="14/medium" className="text-tertiary text-pretty">
        Looking for more? Find everything in your Library
      </Text>
      <Button
        variant="tertiary"
        size="lg"
        className="border-primary bg-primary border"
        onClick={() => navigate('/library')}
      >
        Go to your Library
      </Button>
    </div>
  );
}
